import { createTracker } from 'usage-tracker';
import events from 'framework-asset-preview-lib/events.yaml';
export const UsageTracker = createTracker({
  events,
  properties: {
    namespace: 'framework-asset-preview-lib'
  }
});